<script>
import { required } from 'vuelidate/lib/validators'
import SearchInput from '@components/search-input.vue'

import axios from 'axios'

export default {
  components: {
    SearchInput,
  },
  props: {
    url: {
      type: String,
      default: '/intune/wipe_alerts/list?altorder=createdAt&direction=desc',
    },
  },
  data() {
    return {
      appConfig: {},
      showDownloadCSVButton: false,
      category: 'List',
      items: [
        {
          text: 'Home',
          href: '/',
        },
        {
          text: 'Intune Wipe Alerts',
          active: true,
        },
      ],
      appConfig:
        process.env.NODE_ENV === 'production'
          ? require('@src/app.config')
          : require('@src/app.config.dev'),
      alert: {},
      tableData: [],
      totalRows: 0,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: '',
      fieldsFilter: '',
      sortBy: 'createdAt',
      sortDesc: true,
      searchFields: '',
      showSearchByFields: true,
      tableDetailFields: [
        { key: 'label', label: 'Field' },
        { key: 'visible', label: 'Visible' },
      ],
      fields: [
        {
          key: 'createdAt',
          field: 'createdAt',
          label: 'Created At',
          sortable: true,
          visible: true,
        },
        {
          key: 'totalWipeCount',
          field: 'totalWipeCount',
          label: 'Total Wipes',
          sortable: true,
          visible: true,
        },
        {
          key: 'threshold',
          field: 'threshold',
          label: 'Threshold',
          sortable: false,
          visible: true,
        },
        {
          key: 'timerange',
          field: 'timerange',
          label: 'Time Range',
          sortable: false,
          visible: true,
        },
        {
          key: 'users',
          field: 'wipesByUser',
          label: 'Users',
          sortable: false,
          visible: true,
        },
        {
          key: 'results',
          field: 'wipesByResult',
          label: 'Results',
          sortable: false,
          visible: true,
        },
        { key: 'action', label: 'Action', sortable: false, visible: true },
      ],
      allFields: [
        {
          key: 'createdAt',
          field: 'createdAt',
          label: 'Created At',
          sortable: true,
          visible: true,
        },
        {
          key: 'totalWipeCount',
          field: 'totalWipeCount',
          label: 'Total Wipes',
          sortable: true,
          visible: true,
        },
        {
          key: 'threshold',
          field: 'threshold',
          label: 'Threshold',
          sortable: false,
          visible: true,
        },
        {
          key: 'timerange',
          field: 'timerange',
          label: 'Time Range',
          sortable: false,
          visible: true,
        },
        {
          key: 'users',
          field: 'wipesByUser',
          label: 'Users',
          sortable: false,
          visible: true,
        },
        {
          key: 'results',
          field: 'wipesByResult',
          label: 'Results',
          sortable: false,
          visible: true,
        },
      ],
      fieldsMapping: {},
      isBusy: true,
      searches: {},
      searchType: 'rawsearch',
    }
  },
  validations: {
    event: {
      title: { required },
      category: { required },
    },
  },
  computed: {
    rows() {
      return this.totalRows || 0
    },
  },
  watch: {
    currentPage: {
      handler: function(value) {
        this.loadData(this.filter)
      },
    },
    perPage: {
      handler: function(value) {
        this.loadData(this.filter)
      },
    },
  },
  mounted() {
    this.loadData()
  },
  methods: {
    formatMinutes(minutes) {
      if (minutes === undefined || minutes === null) return 'N/A'
      const mins = parseInt(minutes)
      if (isNaN(mins)) return 'N/A'
      if (mins >= 1440) {
        const days = Math.floor(mins / 1440)
        const remaining = mins % 1440
        if (remaining === 0) return `${days} day${days > 1 ? 's' : ''}`
        const hours = Math.floor(remaining / 60)
        return `${days}d ${hours}h`
      }
      if (mins >= 60) {
        const hours = Math.floor(mins / 60)
        const remaining = mins % 60
        if (remaining === 0) return `${hours} hour${hours > 1 ? 's' : ''}`
        return `${hours}h ${remaining}m`
      }
      return `${mins} min`
    },
    extractUsers(wipesByUser) {
      if (!wipesByUser || typeof wipesByUser !== 'object') return 'N/A'
      return Object.entries(wipesByUser)
        .map(([user, count]) => `${user} (${count})`)
        .join(', ')
    },
    extractResults(wipesByResult) {
      if (!wipesByResult || typeof wipesByResult !== 'object') return 'N/A'
      return Object.entries(wipesByResult)
        .map(([result, count]) => `${result}: ${count}`)
        .join(', ')
    },
    sortedMonthEntries(wipesByMonth) {
      if (!wipesByMonth || typeof wipesByMonth !== 'object') return []
      return Object.entries(wipesByMonth).sort((a, b) => b[0].localeCompare(a[0]))
    },
    loadData(query = '') {
      const that = this
      that.showDownloadCSVButton = false
      that.isBusy = true
      let baseURL = that.appConfig.xdrAPI.baseURL || 'http://localhost:5000'
      const searchType = this.searchType
      const countURL =
        query.length < 1
          ? `${baseURL}${that.url}&count=yes`
          : `${baseURL}${that.url}&${searchType}=${query}&count=yes`

      axios
        .get(countURL)
        .then((response) => {
          that.totalRows = parseInt(response.data)
        })
        .catch(function(error) {})
      let dataURL =
        query.length < 1
          ? `${baseURL}${that.url}&page=${that.currentPage}&page_size=${
              that.perPage
            }`
          : `${baseURL}${that.url}&page=${that.currentPage}&page_size=${
              that.perPage
            }&${searchType}=${query}`
      axios
        .get(dataURL)
        .then((response) => {
          if (response.status === 200) {
            that.isBusy = false
            that.tableData = response.data
          }
          that.showDownloadCSVButton = true
        })
        .catch(function(error) {})
    },
    async downloadCSVFull() {
      const that = this
      try {
        const baseURL = that.appConfig.xdrAPI.baseURL || 'http://localhost:5000'
        const response = await axios.get(
          `${baseURL}/intune/wipe_alerts/list/csv?limit=2000&altorder=createdAt&direction=desc`,
          {
            responseType: 'blob',
          }
        )

        const blob = new Blob([response.data], {
          type: 'text/csv;charset=utf-8;',
        })

        const link = document.createElement('a')
        const url = URL.createObjectURL(blob)

        link.setAttribute('href', url)
        link.setAttribute('download', 'intune_wipe_alerts.csv')
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        URL.revokeObjectURL(url)
      } catch (error) {
        console.error('Error downloading the CSV file:', error)
      }
    },
    modalAlertDetailOk() {
      this.alert = {}
    },
    showDetails(data) {
      if (data === undefined || data.item === undefined) return
      this.alert = data.item
      this.$refs['modal-details'].show()
    },
    doSearch() {
      this.searchType = 'rawsearch'
      let filter = this.filter
      if (filter.length !== undefined) {
        this.loadData(filter)
      }
    },
    configTable() {
      this.$refs['modal-table-config'].show()
    },
    toggleVisibleColumn(data, selected) {
      const that = this
      const visible = selected.visible

      if (visible) {
        if (
          that.fields.filter((field) => field.label === selected.label)
            .length === 0
        ) {
          let newFields = []
          that.allFields.forEach((af) => {
            if (af.label === selected.label) {
              newFields.push(selected)
            } else {
              if (
                that.fields.filter(
                  (field) => field.label === af.label && field.visible
                ).length > 0
              ) {
                newFields.push(af)
              }
            }
          })
          newFields.push({ key: 'action', sortable: false })
          that.fields = newFields
        }
      } else {
        if (
          that.fields.filter((field) => field.label === selected.label).length >
          0
        ) {
          let newFields = that.fields
          if (that.fields.length > 2)
            that.fields = newFields.filter(
              (field) => field.label !== selected.label
            )
          if (that.fieldsMapping[selected.key] !== undefined) {
            delete that.searches[that.fieldsMapping[selected.key]]
            that.doSearchInput()
          }
        }
      }
    },
    modalTableDetaillOk() {},
    generateFilterFromFields() {
      const that = this
      let filter = ''
      Object.keys(that.searches).map((key) => {
        if (that.searches[key] !== undefined && that.searches[key].length > 0) {
          filter += `${key}:${that.searches[key]},`
        }
      })
      return filter.substring(0, filter.length - 1)
    },
    doSearchInput() {
      this.currentPage = 1
      this.searchType = 'mfsearch'
      this.fieldsFilter = this.generateFilterFromFields()
      if (this.fieldsFilter.length !== undefined) {
        this.loadData(this.fieldsFilter)
      }
    },
    fieldSearchChanged(desc, field, text) {
      this.searches[field] = text.trim()
    },
    handlePageChange(page) {
      this.currentPage = page
      this.searchType = 'mfsearch'
      this.fieldsFilter = this.generateFilterFromFields()
      if (this.fieldsFilter.length !== undefined) {
        this.loadData(this.fieldsFilter)
      } else {
        this.loadData()
      }
    },
  },
}
</script>

<template>
  <div>
    <div class="row mb-md-2">
      <div class="col-sm-6 col-md-6">
        <span>
          Alerts found:
          <b>
            {{ rows }}
          </b>
          at
          <b>
            {{ new Date().toLocaleString() }}
          </b>
        </span>
      </div>

      <div class="col-sm-6 col-md-6">
        <div id="tickets-table_filter" class="dataTables_filter text-md-right">
          <label class="d-inline-flex align-items-center">
            <b-form-input
              v-model="filter"
              type="search"
              placeholder="Text to search..."
              class="form-control form-control-sm ml-2"
            />
            <b-button size="sm" variant="light" @click="doSearch">
              Search
            </b-button>
            <b-button size="sm" variant="light" @click="configTable">
              *
            </b-button>
          </label>
        </div>
      </div>
    </div>
    <div class="table-responsive mb-0">
      <b-table
        :items="tableData"
        :fields="fields"
        :busy="isBusy"
        responsive="sm"
        :per-page="0"
        :current-page="currentPage"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :total-rows="totalRows"
        :pagination-options="{
          enabled: true,
        }"
      >
        <template v-slot:table-busy>
          <div class="text-center">
            <br /><br />
            <b-spinner class="align-middle" />
            <strong>&nbsp;&nbsp;Loading...</strong>
          </div>
        </template>

        <template v-slot:cell(createdAt)="data">
          {{ new Date(data.item.createdAt).toLocaleString() }}
        </template>

        <template v-slot:cell(totalWipeCount)="data">
          <span class="severity-high">
            <feather type="alert-octagon" class="icon-xs icon-dual-danger" />
            {{ data.item.totalWipeCount }}
          </span>
        </template>

        <template v-slot:cell(threshold)="data">
          {{ data.item.threshold !== undefined ? data.item.threshold : 'N/A' }}
        </template>

        <template v-slot:cell(timerange)="data">
          {{ formatMinutes(data.item.timerange) }}
        </template>

        <template v-slot:cell(users)="data">
          {{ extractUsers(data.item.wipesByUser) }}
        </template>

        <template v-slot:cell(results)="data">
          {{ extractResults(data.item.wipesByResult) }}
        </template>

        <template v-slot:cell(action)="data">
          <b-dropdown
            right
            variant="white"
            class="align-self-center"
            toggle-class="p-0"
          >
            <template v-slot:button-content>
              <feather
                type="chevron-down"
                class="align-middle"
                style="height:12px !important;width:20px !important;"
              />
            </template>
            <b-dropdown-item class="notify-item" @click="showDetails(data)">
              <feather
                type="search"
                class="icon-dual icon-xs mr-2 align-middle"
              />
              <span>Details</span>
            </b-dropdown-item>
          </b-dropdown>
        </template>
      </b-table>
    </div>
    <div class="row">
      <div class="col-sm-12 col-md-6">
        <div id="tickets-table_length" class="dataTables_length">
          <label class="d-inline-flex align-items-center">
            Show&nbsp;
            <b-form-select
              v-model="perPage"
              size="sm"
              :options="pageOptions"
            />&nbsp;entries
          </label>
          &nbsp;&nbsp;&nbsp;&nbsp;
          <b-button
            v-if="showDownloadCSVButton"
            size="sm"
            variant="light"
            @click="downloadCSVFull"
          >
            Download CSV File (max 2000 entries)
          </b-button>
        </div>
      </div>
      <div class="col">
        <div class="dataTables_paginate paging_simple_numbers float-right">
          <ul class="pagination pagination-rounded mb-0">
            <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              @input="handlePageChange"
            />
          </ul>
        </div>
      </div>
    </div>

    <!-- Detail Modal -->
    <b-modal
      ref="modal-details"
      size="xl"
      title="Intune Wipe Alert Details"
      :centered="true"
      :no-fade="true"
      no-close-on-backdrop
      no-close-on-esc
      hide-header-close
      ok-only
      @ok="modalAlertDetailOk"
    >
      <div class="row mb-3">
        <div class="col-3"><span class="varname">Created At</span></div>
        <div class="col-9"><span class="varcontent">{{ alert.createdAt ? new Date(alert.createdAt).toLocaleString() : '' }}</span></div>
      </div>
      <div class="row mb-3">
        <div class="col-3"><span class="varname">Total Wipe Count</span></div>
        <div class="col-9"><span class="varcontent severity-high">{{ alert.totalWipeCount }}</span></div>
      </div>
      <div class="row mb-3">
        <div class="col-3"><span class="varname">Threshold</span></div>
        <div class="col-9"><span class="varcontent">{{ alert.threshold !== undefined ? alert.threshold : 'N/A' }}</span></div>
      </div>
      <div class="row mb-3">
        <div class="col-3"><span class="varname">Time Range</span></div>
        <div class="col-9"><span class="varcontent">{{ formatMinutes(alert.timerange) }}</span></div>
      </div>

      <hr />
      <h5>Wipes by User</h5>
      <div v-if="alert.wipesByUser">
        <div v-for="(count, user) in alert.wipesByUser" :key="user" class="row mb-1">
          <div class="col-6"><span class="varcontent">{{ user }}</span></div>
          <div class="col-6"><span class="varcontent">{{ count }} wipe{{ count > 1 ? 's' : '' }}</span></div>
        </div>
      </div>
      <div v-else><span class="varcontent">N/A</span></div>

      <hr />
      <h5>Wipes by Result</h5>
      <div v-if="alert.wipesByResult">
        <div v-for="(count, result) in alert.wipesByResult" :key="result" class="row mb-1">
          <div class="col-6"><span class="varcontent">{{ result }}</span></div>
          <div class="col-6"><span class="varcontent">{{ count }}</span></div>
        </div>
      </div>
      <div v-else><span class="varcontent">N/A</span></div>

      <hr />
      <h5>Wipes by Month</h5>
      <div v-if="alert.wipesByMonth">
        <div v-for="[month, count] in sortedMonthEntries(alert.wipesByMonth)" :key="month" class="row mb-1">
          <div class="col-6"><span class="varcontent">{{ month }}</span></div>
          <div class="col-6"><span class="varcontent">{{ count }} wipe{{ count > 1 ? 's' : '' }}</span></div>
        </div>
      </div>
      <div v-else><span class="varcontent">N/A</span></div>
    </b-modal>

    <!-- Table Config Modal -->
    <b-modal
      ref="modal-table-config"
      size="xl"
      title="Table Config"
      :centered="true"
      :no-fade="true"
      ok-only
      @ok="modalTableDetaillOk"
    >
      <b-table :items="allFields" :fields="tableDetailFields" responsive="sm">
        <template v-slot:cell(visible)="data">
          <template v-for="field in allFields">
            <template v-if="data.item.label === field.label">
              <b-form-checkbox
                v-model="field.visible"
                name="check-button"
                switch
                @change="toggleVisibleColumn(data.item, field)"
              />
            </template>
          </template>
        </template>
      </b-table>
    </b-modal>
  </div>
</template>

<style>
.varname {
  font-size: 1.2em;
  font-weight: 700;
}
.varcontent {
  font-size: 1.2em;
  font-weight: 200;
}
.severity-high {
  color: #dc001e;
}
</style>
